<div *ngIf="dateFiltersArr.length > 0" class="filter-date-criteria-text">
  <div *ngFor="let filterItem of dateFiltersArr">
    <div>{{filterItem.name}}: {{filterItem.value}}</div>
  </div>
</div>
<ag-grid-angular
  *ngIf="gridActivated"
  #agGrid
  (gridReady)="onGridReadyInner($event)"
  (selectionChanged)="onSelectionChanged()"
  (sortChanged)="onSortChanged()"
  (filterChanged)="onFilterChanged()"
  (rowClicked)="onRowClicked($event)"
  (firstDataRendered)='onFirstDataRendered()'
  style="flex-grow: 1; justify-content: 'flex-start', width: 100%; height: 100%"
  class="ag-theme-material"
  [ngClass]="gridOptions.enableRtl ? 'he' : 'en'"
  enableCellTextSelection=true
  [localeText]="localeText"
  [rowData]="rows"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [isExternalFilterPresent]="isExternalFilterPresent"
  [doesExternalFilterPass]="doesExternalFilterPass"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  [rowSelection]="'multiple'"
></ag-grid-angular>
